import React, { useEffect } from "react";
import "./Offer_Products.css";
import Common_Heading_Holder from "../../common_components/common_heading_holder/Common_Heading_Holder";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Product_Info_Card from "../../common_components/product_info_card/Product_Info_Card";
import { useDispatch, useSelector } from "react-redux";
import { getOfferProduct } from "../../../features/home/homeSlice";

const Offer_Products = () => {
  const products = [
    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
      company: "Nescafe",
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: true,
      company: "Kellog's",
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },
  ];

  const dispatch = useDispatch();

  const offerProducts = useSelector((state) => state.home.all_offer_product);

  useEffect(() => {
    dispatch(getOfferProduct());
  }, [dispatch]);

  console.log("offerproduct", offerProducts);

  return (
    <section className="Offer_Products">
      <Common_Heading_Holder headingText={"Offer Products"} />

      <div className="main_swiper_div">
        <Swiper
          spaceBetween={15}
          pagination={{
            dynamicBullets: true,
            clickable: true,
          }}
          modules={[Pagination]}
          autoplay={{ delay: 300 }}
          className="common_swiper"
          breakpoints={{
            0: {
              slidesPerView: 1.2,
            },
            380: {
              slidesPerView: 1.5,
            },
            480: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 3,
            },
            768: {
              slidesPerView: 3,
            },
            992: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 3.5,
            },
            1400: {
              slidesPerView: 4,
            },
          }}
        >
          {offerProducts && offerProducts.length > 0 ? (
            offerProducts.map((product) => (
              <SwiperSlide key={product.id}>
                <Product_Info_Card product={product} showQty />
              </SwiperSlide>
            ))
          ) : (
            <div className="text-center py-4">
              <h5>Not Available</h5>
            </div>
          )}
        </Swiper>
      </div>
    </section>
  );
};

export default Offer_Products;

{
  /* <section className='Offer_Products'>
            <Common_Heading_Holder headingText={"Offer Products"} />

            <div className='main_swiper_div'>
                <Swiper
                    spaceBetween={15}
                    pagination={{
                        dynamicBullets: true,
                        clickable: true
                    }}
                    modules={[Pagination]}
                    autoplay={{ delay: 300 }}
                    className="common_swiper"
                    breakpoints={{
                        0: {
                            slidesPerView: 1.2,
                        },
                        380: {
                            slidesPerView: 1.5,
                        },
                        480: {
                            slidesPerView: 2,
                        },
                        768: {
                            slidesPerView: 3,
                        },
                        768: {
                            slidesPerView: 3,
                        },
                        992: {
                            slidesPerView: 3,
                        },
                        1200: {
                            slidesPerView: 3.5,
                        },
                        1400: {
                            slidesPerView: 4,
                        },

                    }}
                >

{
    products?.map((product) => {
        return (
            <SwiperSlide >
                <Product_Info_Card product={product} showQty />
            </SwiperSlide>
        )
    })
}

                </Swiper >
            </div >

        </section> */
}
